import ArquivoComponent from './arquivo.component'

export default ArquivoComponent
